import React, { useState } from "react";
import { useCreditCardValidator, images } from "react-creditcard-validator";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../../../assets/css/Settings/Billing/NewPaymentMethod.css";

function CreditCardForm(setPaymentMethods) {
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCVC] = useState("");

  function expDateValidate(month, year) {
    if (Number(year) > 2035) {
      return "Expiry Date Year cannot be greater than 2035";
    }
    return;
  }

  const {
    getCardNumberProps,
    getCardImageProps,
    getCVCProps,
    getExpiryDateProps,
    meta: { erroredInputs },
  } = useCreditCardValidator({ expiryDateValidator: expDateValidate });

  const handleAddPaymentMethod = () => {
    if (
        erroredInputs.cardNumber ||
        erroredInputs.expiryDate ||
        erroredInputs.cvc
    ) {
      return;
    }

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your logic for handling form submission, e.g., sending data to the server
  };

  return (
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className={"custom-style-settings-menu-minutes-bold mb-2"}>
            Card Number
          </Form.Label>
          <div className={"d-flex"}>
            <Form.Control
                required
                type="text"
                {...getCardNumberProps({
                  value: cardNumber,
                  onChange: (e) => setCardNumber(e.target.value),
                })}
            />
            <svg className={"mt-2"} {...getCardImageProps({ images })} style={{marginLeft:"-25px"}}/>
          </div>
          <Form.Text className="newPayment-error">
            {erroredInputs.cardNumber && erroredInputs.cardNumber}
          </Form.Text>
        </Form.Group>
        <div className={"d-flex"}>
          <Form.Group className="mb-3 w-50">
            <Form.Label
                className={"custom-style-settings-menu-minutes-bold mb-2"}
            >
              Expiry Date
            </Form.Label>
            <Form.Control
                type="text"
                required
                {...getExpiryDateProps({
                  value: expiryDate,
                  onChange: (e) => setExpiryDate(e.target.value),
                })}
            />
            <Form.Text className="newPayment-error">
              {erroredInputs.expiryDate && erroredInputs.expiryDate}
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3 ml-2 w-50">
            <Form.Label
                className={"custom-style-settings-menu-minutes-bold mb-2"}
            >
              CVC
            </Form.Label>
            <Form.Control
                type="text"
                required
                {...getCVCProps({
                  value: cvc,
                  onChange: (e) => setCVC(e.target.value),
                })}
            />
            <Form.Text className="newPayment-error">
              {erroredInputs.cvc && erroredInputs.cvc}
            </Form.Text>
          </Form.Group>
        </div>
        <Button variant="primary" onClick={handleAddPaymentMethod}>
          Add Payment Method
        </Button>
      </Form>
  );
}

export default CreditCardForm;
